import { SpaceAddressFromSpaceId } from '@towns-protocol/web3';
import { ISwapFacet__factory } from '@towns-protocol/generated/dev/typings/factories/ISwapFacet__factory';
import { ISwapRouter__factory } from '@towns-protocol/generated/dev/typings/factories/ISwapRouter__factory';
export function prepareSwapCalls(params) {
    const isSpaceSwap = params.spaceId !== undefined;
    const contractAddress = isSpaceSwap
        ? SpaceAddressFromSpaceId(params.spaceId)
        : params.swapRouterAddress;
    const swapInterface = isSpaceSwap
        ? ISwapFacet__factory.createInterface()
        : ISwapRouter__factory.createInterface();
    const callData = swapInterface.encodeFunctionData('executeSwap', [
        params.exactInputParams,
        params.routerParams,
        params.poster,
    ]);
    const calls = [];
    if (params.approval) {
        if (params.value !== 0n) {
            throw new Error('Value is not 0 for token swap with approval');
        }
        calls.push({
            to: params.approval.toAddress,
            value: 0n,
            data: params.approval.callData,
        });
    }
    calls.push({
        to: contractAddress,
        value: params.value,
        data: callData,
    });
    return calls;
}
export async function executeSwap(params, spaceDapp, smartAccount) {
    if (!spaceDapp) {
        throw new Error('spaceDapp is required');
    }
    const calls = prepareSwapCalls(params);
    const functionHashForPaymasterProxy = 'trading';
    if (calls.length > 1) {
        // Has approval(address, uint256) call
        return smartAccount.sendUserOp({
            toAddress: calls.map((c) => c.to),
            callData: calls.map((c) => c.data),
            signer: params.signer,
            spaceId: undefined,
            value: undefined,
            functionHashForPaymasterProxy,
            skipConfirmation: true,
        });
    }
    else {
        // Single call
        return smartAccount.sendUserOp({
            toAddress: calls[0].to,
            callData: calls[0].data,
            signer: params.signer,
            spaceId: undefined,
            value: params.value,
            functionHashForPaymasterProxy,
            skipConfirmation: true,
        });
    }
}
